// extracted by mini-css-extract-plugin
export var component = "HeaderMainMenu-module--component--i3Ze5";
export var item = "HeaderMainMenu-module--item--ert1H";
export var link = "HeaderMainMenu-module--link--xWOuo";
export var list = "HeaderMainMenu-module--list--8EzED";